import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'serializedComparator',
  standalone: false,
})
export class SerializedComparatorPipe implements PipeTransform {
  transform(value: any, comparisonString: string): boolean {
    const serializedValue = JSON.stringify(value);
    return serializedValue == comparisonString;
  }
}
